import React from 'react';

const COLORS = {
  neutral:    { fg: 'var(--label-neutral)',     weak: 'var(--fill-normal)',                    solid: 'var(--label-neutral)' },
  primary:    { fg: 'var(--primary-normal)',    weak: 'var(--accent-background-light-blue)',   solid: 'var(--primary-normal)' },
  positive:   { fg: 'var(--status-positive)',   weak: 'rgba(0,191,64,0.10)',                   solid: 'var(--status-positive)' },
  negative:   { fg: 'var(--status-negative)',   weak: 'rgba(255,66,66,0.10)',                  solid: 'var(--status-negative)' },
  cautionary: { fg: 'var(--status-cautionary)', weak: 'rgba(255,153,0,0.12)',                  solid: 'var(--status-cautionary)' },
  violet:     { fg: 'var(--accent-foreground-violet)', weak: 'var(--accent-background-violet)', solid: 'var(--accent-foreground-violet)' },
};

const SIZES = {
  medium: { h: 24, padX: 8, font: 'var(--font-size-label-2)' },
  small:  { h: 20, padX: 6, font: 'var(--font-size-caption-1)' },
};

/** Compact content label (Wanted "Content Badge") — e.g. 정규직, 신입, 인증. */
export function Tag({ children, color = 'neutral', variant = 'weak', size = 'medium', style }) {
  const c = COLORS[color] || COLORS.neutral;
  const s = SIZES[size] || SIZES.medium;
  const look =
    variant === 'solid'
      ? { background: c.solid, color: 'var(--static-white)', boxShadow: 'none' }
      : variant === 'outline'
      ? { background: 'transparent', color: c.fg, boxShadow: `inset 0 0 0 1px ${c.fg}` }
      : { background: c.weak, color: c.fg, boxShadow: 'none' };
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        height: s.h,
        padding: `0 ${s.padX}px`,
        borderRadius: 'var(--radius-xs)',
        fontFamily: 'var(--font-sans)',
        fontSize: s.font,
        fontWeight: 600,
        lineHeight: 1,
        whiteSpace: 'nowrap',
        ...look,
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export default Tag;
